import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectCarSelector = state => state.get('carSelector', initialState);

const makeSelectIsLoading = () =>
  createSelector(selectCarSelector, carSelectorState =>
    carSelectorState.get('loading'),
  );

const makeSelectDownloadIsLoading = () =>
  createSelector(selectCarSelector, carSelectorState =>
    carSelectorState.get('downloadLoading'),
  );

const makeSelectBrands = () =>
  createSelector(selectCarSelector, carSelectorState =>
    carSelectorState.get('brands'),
  );

const makeSelectSelectedBrand = () =>
  createSelector(selectCarSelector, carSelectorState =>
    carSelectorState.get('selectedBrand'),
  );

const makeSelectSelectedModel = () =>
  createSelector(selectCarSelector, carSelectorState =>
    carSelectorState.get('selectedModel'),
  );

const makeSelectSelectedModelName = () =>
  createSelector(selectCarSelector, carSelectorState =>
    carSelectorState.get('selectedModelName'),
  );
const makeSelectSelectedModelYear = () =>
  createSelector(selectCarSelector, carSelectorState =>
    carSelectorState.get('selectedModelYear'),
  );

const makeSelectSelectedVersion = () =>
  createSelector(selectCarSelector, carSelectorState =>
    carSelectorState.get('selectedVersion'),
  );

const makeSelectModels = () =>
  createSelector(selectCarSelector, carSelectorState => [
    ...carSelectorState.get('models'),
  ]);

const makeSelectVersions = () =>
  createSelector(selectCarSelector, carSelectorState => [
    ...carSelectorState.get('versions'),
  ]);

const makeSelectCar = () =>
  createSelector(selectCarSelector, carSelectorState =>
    carSelectorState.get('car').toJS(),
  );

const makeSelectCarCode = () =>
  createSelector(
    selectCarSelector,
    carSelectorState => carSelectorState.get('car').toJS().id,
  );

const makeSelectImages = () =>
  createSelector(selectCarSelector, carSelectorState =>
    carSelectorState.get('images'),
  );

const makeIsCarSelectorComplete = () =>
  createSelector(selectCarSelector, carSelectorState => {
    return carSelectorState.get('selectedBrand') !== null
        && carSelectorState.get('car').toJS() !== null
        && carSelectorState.get('car').toJS().hasOwnProperty('allestimento') !== false
  });

export {
  makeSelectIsLoading,
  makeSelectDownloadIsLoading,
  makeSelectBrands,
  makeSelectSelectedBrand,
  makeSelectModels,
  makeSelectSelectedModel,
  makeSelectSelectedModelName,
  makeSelectSelectedModelYear,
  makeSelectVersions,
  makeSelectSelectedVersion,
  makeSelectCar,
  makeSelectCarCode,
  makeSelectImages,
  makeIsCarSelectorComplete,
};
